import Select, { type SingleValue } from 'react-select';
import { FILTER_SELECT_WIDTH, filterSelectStyles } from './selectStyles';
import type { SelectOption } from './selectTypes';

type Props = {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number | string;
  isLoading?: boolean;
  isDisabled?: boolean;
  isClearable?: boolean;
};

export const FilterSelect = ({
  options,
  value,
  onChange,
  placeholder = 'Выбрать...',
  width = FILTER_SELECT_WIDTH,
  isLoading,
  isDisabled,
  isClearable = true,
}: Props) => {
  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <Select
      isClearable={isClearable}
      isSearchable
      isLoading={isLoading}
      isDisabled={isDisabled}
      placeholder={placeholder}
      options={options}
      value={selected}
      onChange={(next: SingleValue<SelectOption>) => onChange(next?.value ?? '')}
      noOptionsMessage={() => 'Нет вариантов'}
      styles={filterSelectStyles(width)}
      classNamePrefix="filter-select"
    />
  );
};
